module.exports = __webpack_public_path__ + "img/rope.6172e743.jpeg";